<app-home-slider></app-home-slider>

<div class="home-block-2">
    <div class="block2-container">
        <div class="cards-row">
            <!-- Card 1 -->
            <div class="count-card year">
                <div class="card-icon">
                    <img src="assets/images/icons/book_mark_white.png" alt="book_mark_white icon">
                </div>
                <div class="card-content">
                    <div class="card-title"><span>+</span>12</div>
                    <div class="card-subtitle">Années d'expérience</div>
                </div>
            </div>

            <!-- Card 2 -->
            <div class="count-card users">
                <div class="card-icon">
                    <img src="assets/images/icons/user_check_white.png" alt="user_check_white icon">
                </div>
                <div class="card-content">
                    <div class="card-title"><span>+</span>650</div>
                    <div class="card-subtitle">Clients satisfait</div>
                </div>
            </div>

            <!-- Card 3 -->
            <div class="count-card events">
                <div class="card-icon">
                    <img src="assets/images/icons/shield_check_white.png" alt="shield_check_white icon">
                </div>
                <div class="card-content">
                    <div class="card-title"><span>+</span>230</div>
                    <div class="card-subtitle">Evènements sécurisé</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="alternating-blocks">
    <div *ngFor="let block of blocks; let i = index" class="alternating-block" [class.reverse]="i % 2 === 0">
        <!-- Image Column -->
        <div class="block-image">
            <img [src]="block.imageUrl" [alt]="block.altText" class="image">
        </div>

        <!-- Content Column -->
        <div class="block-content">
            <h2 class="block-title">{{ block.title }}</h2>
            <p class="block-description">{{ block.description }}</p>

            <!-- Services list if exists -->
            <ul *ngIf="block.services" class="services-list">
                <li *ngFor="let service of block.services" class="service-item">
                    {{ service }}
                </li>
            </ul>

            <!-- Link with icon -->
            <a [href]="block.linkUrl" class="service-link">
                <img src="assets/images/icons/shield_check.png" alt="Shield icon" class="link-icon">
                <span class="link-text">Demander notre service</span>
                <img src="assets/images/icons/link_arrow.png" alt="Arrow" class="arrow-icon">
            </a>
        </div>
    </div>
</div>